// Adapters for the public number coverage data (/api/public/coverage), mapping it into the shape the website pages
// already use. The website shows availability and regulations only, never prices.
import { flagCode } from './flags';

/**
 * One country from /api/public/coverage (a list entry with `types`, or the detail with `offers`) as
 * { country, country_code, local, national, mobile, twoway, itfs, uifn, prefixes, rules, address, documents, outbound }.
 * address / documents are the list's short regulation summary (services/coverage.summarise_rules). Any price fields are dropped.
 */
export const toCountryRecord = (c) => {
  if (!c) return c;
  const kinds = new Set([...Object.keys(c.types || {}), ...(c.offers || []).map((o) => o.number_kind)]);
  return {
    country: c.country,
    country_code: flagCode(c.country),
    local: kinds.has('local'),
    national: kinds.has('national'),
    mobile: kinds.has('mobile'),
    twoway: kinds.has('2way') || kinds.has('uc'),
    itfs: kinds.has('tollfree'),
    uifn: kinds.has('uifn'),
    prefixes: [],
    rules: c.rules || [],
    address: c.address || null,
    documents: c.documents || null,
    outbound: Boolean(c.outbound_available),
  };
};

// Regulatory page sections and the number kinds each one covers.
const SECTION_KINDS = { local: ['local'], national: ['national'], mobile: ['mobile'], twoway: ['2way', 'uc'], tollFree: ['tollfree'], uifn: ['uifn'] };

/** Regulation entries keyed by page section (local, national, mobile, twoway, tollFree, uifn). */
export const requirementsByType = (rules = []) => {
  const out = {};
  Object.entries(SECTION_KINDS).forEach(([section, kinds]) => {
    const rule = rules.find((r) => (r.kinds || []).some((k) => kinds.includes(k)));
    if (rule) out[section] = rule;
  });
  return out;
};
